import { type FC } from "react";
import { useParams } from "react-router";
import { FollowUpWrapper } from "../../modules/follow-up/component/follow-up-wrapper";
import { Page } from "../../modules/layout/components/page";
import { useFlags } from "../../server/optimizely";
import type { UUID } from "../../utils/uuid";
import NotFound from "../not-found";

const FollowUpPage: FC = () => {
  const {
    flags: { enable_follow_up_page },
    flagsLoaded,
  } = useFlags("enable_follow_up_page");

  // TODO: Switch to query params?
  const { id: moment_id } = useParams() as { id: UUID };

  if (!flagsLoaded) return null;

  if (!enable_follow_up_page) return <NotFound />;

  return (
    <Page title="Follow Up | ChangeEngine" sx={{ height: "100%" }}>
      <FollowUpWrapper moment_id={moment_id} />
    </Page>
  );
};

export default FollowUpPage;
